<template>
  <card-seplag titulo="Validação de Licença Prêmio pela chefia">
    <div class="p-grid p-col-12 p-align-end" style="margin-top: 10px">
      <Rotulo cols="12 3" nome="Setor:">
        <Dropdown v-model="unidadeSelecionada" :options="listaUnidades" optionLabel="labelDropDaw"
          placeholder="Selecione..." filter :disabled="false" @change="limparConsulta()" />
      </Rotulo>
      <Rotulo cols="12 3" nome="Situação">
        <Dropdown v-model="situacaoSelecionada" :options="situacoes" optionLabel="label" placeholder="Selecione..."
          showClear />
      </Rotulo>
      <div class="p-md-2 p-col-12">
        <Button label="Buscar" icon="pi pi-search" class="p-button-info" @click="clicouBuscar()" />
      </div>
    </div>

    <div class="p-grid p-col-12" style="margin-top: 10px">
      <table-seplag :dados="dadosTabelaPendentes" :exibirCabecalho="false" :paginacao="true" :campos="[]"
        :onSearchPaginacao="buscarDadosTabela" :totalRegistro="totalRegistro">
        <Column field="matricula" header="Matrícula" :headerStyle="`width: 3%;`">
          <template #body="slotProps">
            {{ slotProps.data.matricula }}
          </template>
        </Column>
        <Column header="Quinquênio" headerStyle="width: 14em; justify-content: center;"
          bodyStyle="text-align: center;">
          <template #body="slotProps">
           {{ slotProps.data.dataInicioPeriodoAquisitivo }} à {{ slotProps.data.dataFimPeriodoAquisitivo }}
          </template>
        </Column>
        <Column header="Data Início" headerStyle="width: 14em; justify-content: center;"
          bodyStyle="text-align: center;">
          <template #body="slotProps">
            <span>
              {{ slotProps.data.dataInicio }}
            </span>
          </template>
        </Column>
        <Column header="Data Término" headerStyle="width: 14em; justify-content: center;"
          bodyStyle="text-align: center;">
          <template #body="slotProps">
            <span>
              {{ slotProps.data.dataFim }}
            </span>
          </template>
        </Column>
        <Column header="Origem" headerStyle="width: 10em; text-align: center" bodyStyle="text-align: center">
          <template #body="slotProps">
            <span>
              {{ slotProps.data.origem ? slotProps.data.origem : "" }}
            </span>
          </template>
        </Column>
        <Column v-if="mostrarPendentes" headerStyle="width: 9em" bodyStyle="text-align: center" header="Situação">
          <template #body="slotProps">
            <span class="customer-badge-pendente">
              {{ slotProps.data.status }}
            </span>
          </template>
        </Column>
        <Column v-if="!mostrarPendentes" field="status" headerStyle="width: 10em; justify-content: center;"
          header="Situação" headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento">
          <template #body="slotProps">
            <Button :class="'p-button-text status-' + slotProps.data.status" type="button"
              @click="showModalJustificativa(slotProps.data.justificativa)" v-tooltip.top="slotProps.data.justificativa
                  ? 'Ver Justificativa'
                  : 'Não Possui Justificativa'
                " :label="slotProps.data.status" />
          </template>
        </Column>
        <Column header="Aprovador" headerStyle="width: 14em; justify-content: center;"
          bodyStyle="text-align: center;">
          <template #body="slotProps">
            <div class="colunaAprovador">
              <span>{{ aprovadorNome(slotProps.data) }}</span><br />
              <span>{{ aprovadorSetor(slotProps.data) }}</span>
            </div>
          </template>
        </Column>
        <Column v-if="mostrarPendentes" headerStyle="width: 6em" bodyStyle="text-align: center;" header="Ação">
          <template #body="slotProps">
            <Button type="button" icon="pi pi-id-card" v-tooltip.top="'Aprovação'" @click="showModal(slotProps.data)"
              :disabled="slotProps.data.situacao == 'ENCERRADO'" />
          </template>
        </Column>
      </table-seplag>
    </div>

    <cadastro-rapido tamanhoTela="40rem" tituloTela="Aprovação" v-model="exibirTela" :modoEdicao="modoEdicao"
      :onAdicionar="validaRegistro" :onfecharModal="fecharModalValidaEscala" optionValue="code" :textoButton="'Salvar'">
      <div class="p-col-12">
        <Fieldset v-if="dadosAprovacao">
          <template #legend>
            <strong>Servidor</strong>
          </template>
          <p>
            <strong>Matricula: </strong>
            {{ dadosAprovacao.matricula ? dadosAprovacao.matricula : "" }} -
            <strong>Vinculo: </strong>
            {{
              dadosAprovacao.numeroVinculo
                ? dadosAprovacao.numeroVinculo
                : ""
            }}
          </p>
          <p>
            <strong>Candidato: </strong>
            {{ dadosAprovacao.nome ? dadosAprovacao.nome : "" }}
          </p>
          <p>
            <strong>Periodo de Usufruto: </strong>
            {{ dadosAprovacao.dataInicio ? dadosAprovacao.dataInicio : "" }} à
            {{ dadosAprovacao.dataFim ? dadosAprovacao.dataFim : "" }}
          </p>
          <p v-if="dadosAprovacao.dataInicioTemporario">
            <strong>Alterado para </strong>{{ dadosAprovacao.dataInicioTemporario }} à
            {{ dadosAprovacao.dataFimTemporario }}
          </p>
        </Fieldset>
      </div>
      <Rotulo nome="Deferido" cols="12">
        <SelectButton name="deferido" v-model="registro.statusProgramacao" :options="simNao" optionLabel="name"
          optionValue="code" v-required />
      </Rotulo>
      <Rotulo nome="Motivo Rejeição:" cols="12" v-if="registro.statusProgramacao == 'N'">
        <Dropdown name="motivoRejeicao" v-model="registro.motivoRejeicao" :options="motivoRejeicao" v-required />
      </Rotulo>
      <Rotulo nome="Justificativa:" cols="12">
        <Textarea v-model="registro.observacao" rows="5" cols="30" />
      </Rotulo>
    </cadastro-rapido>

    <cadastro-rapido tituloTela="Justificativa" :tamanhoTela="'30vw'" v-model="exibirTelaJustificativa"
      textoButtonFechar="Fechar" :visivelbotao="true" :onfecharModal="fecharModalJustificativa">
      <p style="text-align: justify" v-html="justificativaSelecionada ? justificativaSelecionada : 'Não Informado'
        " />
    </cadastro-rapido>
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import TableSeplag from "@/template/TableSeplag.vue";
import { baseApiUrl, simNao } from "@/config/global";

const getDefaultState = () => {
  return {
    matriculaValidador: null,
    numeroVinculoValidador: null,
    idReg: null,
    proximaSituacao: null,
    chaveperaqlesp: null,
    motivoRejeicao: null,
    chavePend: null,
    observacao: null,
    statusProgramacao: null,
  };
};

export default {
  name: "ChefiaValidacaoLicencaPremio",
  components: { CardSeplag, CadastroRapido, Rotulo, TableSeplag },
  data() {
    return {
      simNao: simNao,
      dadosTabelaPendentes: [],
      dadosAprovacao: null,
      motivoRejeicao: [],
      totalRegistro: 0,
      tamanhoPorpagina: 10,
      modoEdicao: "adicionar",
      registro: getDefaultState(),
      exibirTela: false,
      exibirTelaJustificativa: false,
      justificativaSelecionada: null,
      listaUnidades: [],
      unidadeSelecionada: null,
      situacoes: [
        { label: "Pendente", value: "PENDENTE" },
        { label: "Validado", value: "APROVADO" },
        { label: "Reprovado", value: "REPROVADO" },
      ],
      situacaoSelecionada: null,
      situacaoConsultada: null,
      matriculaChefe: null,
      vinculoChefe: null,
    };
  },
  computed: {
    mostrarPendentes() {
      return this.situacaoConsultada === "PENDENTE";
    },
  },
  methods: {
    async carregarDados() {
      this.matriculaChefe = this.$store.getters.getMatricula;
      this.vinculoChefe = this.$store.getters.getVinculo;

      await this.$http
        .get(
          `${baseApiUrl}/lincencaview/chefia/hierarquiaUnidades/${this.matriculaChefe}/${this.vinculoChefe}`
        )
        .then((respUnidades) => {
          this.listaUnidades = respUnidades.data.map(function (element) {
            return {
              ...element,
              labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
            };
          });
        });

      this.unidadeSelecionada = this.unidadeSelecionada
        ? this.unidadeSelecionada
        : this.listaUnidades[0];
    },
    clicouBuscar() {
      if (!this.unidadeSelecionada) {
        this.$toast.add({
          severity: "error",
          summary:
            "Seleção de Setor Obrigatório, Por favor Selecione um Setor",
          life: 3000,
        });
        return;
      }
      if (!this.situacaoSelecionada) {
        this.$toast.add({
          severity: "error",
          summary:
            "Seleção de Situação Obrigatória, Por favor Selecione uma Situação",
          life: 3000,
        });
        return;
      }
      this.situacaoConsultada = this.situacaoSelecionada.value;
      this.buscarDadosTabela();
    },
    async buscarDadosTabela(size = 10, page = 0) {
      if (!this.situacaoConsultada || !this.unidadeSelecionada) {
        return;
      }
      const urlPaginacao = `lincencaview/chefia/lista/${this.matriculaChefe}/${this.vinculoChefe}/${this.situacaoConsultada}`;

      try {
        const respLicencas = await this.$http.get(
          `${baseApiUrl}/${urlPaginacao}/${this.unidadeSelecionada.codgSeap}?size=${size}&page=${page}`
        );
        this.totalRegistro = respLicencas.data.totalElements;

        if (this.mostrarPendentes) {
          this.dadosTabelaPendentes = respLicencas.data.content;
          await this.carregarMotivosRejeicao();
          return;
        }

        this.dadosTabelaPendentes = respLicencas.data.content;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro ao carregar licenças",
          detail: error.message,
          life: 3000,
        });
      }
    },
    async carregarMotivosRejeicao() {
      const respMotivos = await this.$http.get(
        `${baseApiUrl}/lincencaview/validar/motivo/rejeicao`
      );
      this.motivoRejeicao = respMotivos.data;
    },
    limparConsulta() {
      this.dadosTabelaPendentes = [];
      this.totalRegistro = 0;
      this.situacaoConsultada = null;
    },
    fecharModalValidaEscala() {
      this.registro = getDefaultState();
      this.dadosAprovacao = null;
      this.exibirTela = false;
    },
    showModal(dados) {
      this.registro.matriculaValidador = this.$store.getters.getMatricula;
      this.registro.numeroVinculoValidador = this.$store.getters.getVinculo;
      this.registro.idReg = dados.idReg;
      this.registro.proximaSituacao = null;
      this.registro.chavePeriodoAquisitivo = dados.chavePeriodoAquisitivo;
      this.registro.chavePend = dados.chavePend;
      this.dadosAprovacao = dados;
      this.exibirTela = true;
    },
    validaRegistro() {
      if (!this.registro.statusProgramacao) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Informe se o pedido foi deferido",
          life: 3000,
        });
        return;
      }
      if (this.registro.statusProgramacao == "N" && !this.registro.motivoRejeicao) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Informe o motivo da rejeição",
          life: 3000,
        });
        return;
      }
      if (this.registro.statusProgramacao == "N" && !this.registro.observacao) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail:
            "A justificativa é OBRIGATORIA quando o pedido de Licença for negado",
          life: 3000,
        });
        return;
      }

      this.registro.aprovado = this.registro.statusProgramacao == "N" ? false : true;

      this.$http
        .post(
          `${baseApiUrl}/lincencaview/validarRejeitarLicenca/${this.registro.idReg}`,
          JSON.stringify(this.registro)
        )
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Registro validado com sucesso",
            life: 3000,
          });
          this.fecharModalValidaEscala();
          this.buscarDadosTabela();
        });
    },
    fecharModalJustificativa() {
      this.justificativaSelecionada = null;
      this.exibirTelaJustificativa = false;
    },
    showModalJustificativa(justificativa) {
      if (justificativa) {
        this.justificativaSelecionada = justificativa;
        this.exibirTelaJustificativa = true;
        return;
      }

      this.$toast.add({
        severity: "error",
        summary: "justificativa Não Cadastrada",
        life: 3000,
      });
    },
    parseAprovador(servidor) {
      if (!servidor || !servidor.aprovador) {
        return null;
      }
      if (typeof servidor.aprovador === "string") {
        try {
          return JSON.parse(servidor.aprovador);
        } catch (e) {
          return null;
        }
      }
      return servidor.aprovador;
    },
    aprovadorNome(servidor) {
      const aprovador = this.parseAprovador(servidor);
      return aprovador ? aprovador.nome : "";
    },
    aprovadorSetor(servidor) {
      const aprovador = this.parseAprovador(servidor);
      return aprovador ? aprovador.nomeSetor : "";
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style scoped>
.customer-badge-pendente {
  border-radius: 2px;
  padding: 0.25em 0.5em;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  background-color: rgb(219, 171, 81);
  color: aliceblue;
}

.status-APROVADO {
  background-color: #c8e6c9;
  color: #256029;
}

.status-APROVADO:active,
.status-APROVADO:hover {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
}

.status-APROVADO:focus {
  box-shadow: 0 0 0 0.2rem #c8e6c9;
}

.status-APROVADORH {
  background-color: #c8e6c9;
  color: #256029;
}

.status-APROVADORH:active,
.status-APROVADORH:hover {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
}

.status-APROVADORH:focus {
  box-shadow: 0 0 0 0.2rem #c8e6c9;
}

.status-REPROVADO {
  background-color: #ffcdd2;
  color: #c63737;
}

.status-REPROVADO:active,
.status-REPROVADO:hover {
  background-color: #ffcdd2 !important;
  color: #c63737 !important;
}

.status-REPROVADO:focus {
  box-shadow: 0 0 0 0.2rem #ffcdd2;
}

.status-PENDENTE {
  background-color: #feedaf;
  color: #8a5340;
}

.status-PENDENTE:active,
.status-PENDENTE:hover {
  background-color: #feedaf !important;
  color: #8a5340 !important;
}

.status-PENDENTE:focus {
  box-shadow: 0 0 0 0.2rem #feedaf;
}

.status-PUBLICADO,
.status-EFETIVADO {
  background-color: #b3e5fc;
  color: #23547b;
}

.status-PUBLICADO:active,
.status-PUBLICADO:hover,
.status-EFETIVADO:active,
.status-EFETIVADO:hover {
  background-color: #b3e5fc !important;
  color: #23547b !important;
}

.status-PUBLICADO:focus,
.status-EFETIVADO:focus {
  box-shadow: 0 0 0 0.2rem #b3e5fc;
}

.status-VALIDADO {
  background-color: #eccfff;
  color: #694382;
}

.status-VALIDADO:active,
.status-VALIDADO:hover {
  background-color: #eccfff !important;
  color: #694382 !important;
}

.status-VALIDADO:focus {
  box-shadow: 0 0 0 0.2rem #eccfff;
}

.status-VIASEAP {
  background-color: #b4b3af;
  color: #3f3e3d;
}

.status-VIASEAP:active,
.status-VIASEAP:hover {
  background-color: #b4b3af !important;
  color: #3f3e3d !important;
}

.status-VIASEAP:focus {
  box-shadow: 0 0 0 0.2rem #b4b3af;
}

.situacaoColunaFeriasAgendamento>div {
  justify-content: center;
}

.botaoColunaSituacaoFeriasAgendamento {
  text-align: center !important;
}
</style>
